import FlyerSalesListContainer from '../../containers/flyerSalesList/flyerSalesList';

function FlyerSalesList() {
  return <FlyerSalesListContainer />;
}

export default FlyerSalesList;
